import styled, { css } from 'styled-components'
import { rem, transitions } from 'polished'

export const Section = styled.section`
  padding-bottom: ${rem(43)};

  ${({ theme }) => theme.mediaQueries.medium} {
    padding-bottom: ${rem(44)};
  }
`

export const NavigationContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin: 0 auto;
  padding: ${rem(16)} ${rem(32)};
  justify-content: flex-start;
  column-gap: ${rem(20)};
  overflow: auto;

  ${({ theme }) => theme.mediaQueries.medium} {
    overflow: initial;
    padding: ${rem(40)} ${rem(32)};
    margin-bottom: ${rem(40)};
    justify-content: center;
  }
`

export const Tab = styled.button`
  ${transitions(
    [
      'border',
      'font-weight',
      'font-size',
      'opacity',
      'font-family',
      'min-width',
      'padding-bottom',
    ],
    '0.3s'
  )}
  width:220px;
  border: none;
  border-bottom: 3px solid transparent;
  background-color: transparent;
  font-weight: 300;
  opacity: 0.3;
  font-family: ${({ theme }) => theme.textStyles.brownStd.fontFamily};
  font-size: ${rem(14)};
  padding: 0px;
  padding-bottom: ${rem(8)};
  white-space: nowrap;
  border-bottom: 2px solid #cfd4da;
  text-transform: uppercase !important;
  color: ${({ theme }) => theme.colors.black};

  ${(props) =>
    props.isActive &&
    css`
      font-family: ${({ theme }) => theme.textStyles.brownStd.fontFamily};
      border-bottom: 4px solid ${({ theme }) => theme.colors.radiantGreen};
      font-weight: 400;
      opacity: 1;
    `}
  ${({ theme }) => theme.mediaQueries.medium} {
    min-width: ${rem(180)};
    font-size: ${rem(16)};
    padding-bottom: ${rem(16)};
    text-transform: initial;
  }
`
